// To optimize animation frames, request them for max period of time
const ANIMATION_MAX_DURATION = 100

// Scale scroll offset distance
const SCROLL_DISTANCE_COEF = 2

const HEADER_FULL_HEIGHT = 120
const HEADER_MIN_HEIGHT = 60

// Scale for the logo in fully minified header
const HEADER_LOGO_SCALE = 0.75

export default function initHeader() {
    const hdrEl = document.getElementById('hdr-top')
    const menuEl = document.getElementById('hdr-menu')
    const menuInnerEl = menuEl.querySelector('.hdr-menu-inner')
    const menuBtnEl = hdrEl.querySelector('.hdr-menuBtn')
    const logoImgEl = hdrEl.querySelector('.hdr-logo img')
    const stickyButton = hdrEl.querySelector('.wa-sticky-button')

    let animateRequestsCnt = 0
    let af = null

    if (stickyButton) {
        setTimeout(() => {
            stickyButton.classList.add('is--visible')
        }, 5000)
    }

    animateForAWhile()
    window.addEventListener('scroll', animateForAWhile)
    window.addEventListener('resize', onResize)
    window.addEventListener('orientationchange', onResize)

    window.addEventListener('beforeunload', hideMenu)

    document.body.addEventListener('click', event => {
        if (isMenuOpen() && (event.target !== hdrEl && !hdrEl.contains(event.target))) {
            hideMenu()
        }
    })

    menuBtnEl.addEventListener('click', toggleMenu)

    function onResize() {
        animateForAWhile()
        if (isMenuOpen()) {
            menuEl.style.height = `${menuInnerEl.scrollHeight}px`
        }
    }

    function toggleMenu() {
        isMenuOpen() ? hideMenu() : showMenu()
    }

    function isMenuOpen() {
        return menuEl.classList.contains('is--visible')
    }

    function showMenu() {
        menuEl.style.height = `${menuInnerEl.scrollHeight}px`
        menuBtnEl.setAttribute('aria-expanded', 'true')
        menuBtnEl.classList.add('is-active')
        menuEl.classList.add('is--visible')
        document.body.classList.add('has--headerMenuVisible')
    }

    function hideMenu() {
        menuEl.style.height = '0'
        menuBtnEl.setAttribute('aria-expanded', 'false')
        menuBtnEl.classList.remove('is-active')
        menuEl.classList.remove('is--visible')
        document.body.classList.remove('has--headerMenuVisible')
    }

    function animateForAWhile() {
        animateRequestsCnt += 1
        if (!af) {
            af = window.requestAnimationFrame(animateHeader)
        }
        setTimeout(() => {
            animateRequestsCnt -= 1
            if (animateRequestsCnt <= 0) {
                stopAnimation()
            }
        }, ANIMATION_MAX_DURATION)
    }

    function animateHeader() {
        if (window.pageYOffset <= 0) {
            hdrEl.style.height = ''
            hdrEl.classList.remove('is--min')
            logoImgEl.style.transform = `scale(1)`
        } else if (window.pageYOffset < HEADER_MIN_HEIGHT * SCROLL_DISTANCE_COEF) {
            hdrEl.style.height = `${HEADER_FULL_HEIGHT - window.pageYOffset / SCROLL_DISTANCE_COEF}px`
            hdrEl.classList.remove('is--min')
            logoImgEl.style.transform = `scale(${1 - (window.pageYOffset / HEADER_FULL_HEIGHT * (1 - HEADER_LOGO_SCALE))})`
        } else {
            hdrEl.style.height = ''
            hdrEl.classList.add('is--min')
            logoImgEl.style.transform = `scale(${HEADER_LOGO_SCALE})`
        }
        if (window.pageYOffset < HEADER_MIN_HEIGHT * SCROLL_DISTANCE_COEF / 2) {
            hdrEl.classList.remove('hide--tagline')
        } else {
            hdrEl.classList.add('hide--tagline')
        }
        af = window.requestAnimationFrame(animateHeader)
    }

    function stopAnimation() {
        window.cancelAnimationFrame(af)
        af = null
    }
}
